export default "/images/tag.svg?00341c400f8266a201fd9150eafe62dc";